var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* eslint-disable no-underscore-dangle */
import { injectable } from 'inversify';
import { Logger } from '../logger';
export var GoalsEnum;
(function (GoalsEnum) {
    GoalsEnum["useFilter"] = "useFilter";
    GoalsEnum["openLink"] = "openLink";
    GoalsEnum["copyToClipboard"] = "copyToClipboard";
    GoalsEnum["selectItems"] = "selectItems";
    GoalsEnum["downloadItems"] = "downloadItems";
    GoalsEnum["documentZoom"] = "documentZoom";
    GoalsEnum["eventCancel"] = "eventCancel";
    GoalsEnum["eventCancelReason"] = "eventCancelReason";
    GoalsEnum["eventDocOriginalPrint"] = "eventDocOriginalPrint";
    GoalsEnum["eventDocDownload"] = "eventDocDownload";
    GoalsEnum["eventFlowDownload"] = "eventFlowDownload";
    GoalsEnum["eventFlowOpen"] = "eventFlowOpen";
    GoalsEnum["eventFlowPrint"] = "eventFlowPrint";
    GoalsEnum["vacationEventFlowOpen"] = "vacationEventFlowOpen";
    GoalsEnum["vacationEventFlowPrint"] = "vacationEventFlowPrint";
    GoalsEnum["createEvent"] = "createEvent";
    GoalsEnum["updateEventFlow"] = "updateEventFlow";
})(GoalsEnum || (GoalsEnum = {}));
var UserRoleEnum;
(function (UserRoleEnum) {
    UserRoleEnum["Employee"] = "employee";
    UserRoleEnum["Company"] = "company";
})(UserRoleEnum || (UserRoleEnum = {}));
let AnalyticService = class AnalyticService {
    constructor(logger) {
        this.logger = logger;
        this.tmr = window._tmr;
    }
    setUser(id) {
        var _a;
        if (window.REACT_APP_VKHRTEK_MY_TRACKER_ID) {
            (_a = this.tmr) === null || _a === void 0 ? void 0 : _a.push({ type: 'setUserID', userid: id });
        }
        else {
            this.logger.debug(`Аналитика не включена. Цель: 'setUserID', userId: ${id}`);
        }
    }
    pageView(userId) {
        var _a;
        if (window.REACT_APP_VKHRTEK_MY_TRACKER_ID) {
            (_a = this.tmr) === null || _a === void 0 ? void 0 : _a.push({
                id: window.REACT_APP_VKHRTEK_MY_TRACKER_ID,
                type: 'pageView',
                start: new Date().getTime(),
                userid: userId,
            });
        }
        else {
            this.logger.debug(`Аналитика не включена. Цель: 'pageView', userId: ${userId}`);
        }
    }
    registerAction(goal, params) {
        var _a;
        if (window.REACT_APP_VKHRTEK_MY_TRACKER_ID) {
            (_a = this.tmr) === null || _a === void 0 ? void 0 : _a.push({
                id: window.REACT_APP_VKHRTEK_MY_TRACKER_ID,
                type: 'reachGoal',
                goal,
                params,
            });
        }
        else {
            this.logger.debug(`Аналитика не включена. Цель: ${goal}, Параметры: ${JSON.stringify(params)}`);
        }
    }
};
AnalyticService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [Logger])
], AnalyticService);
export { AnalyticService };
